"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelProvider = void 0;
const types_1 = require("@connext/types");
class ChannelProvider extends types_1.ConnextEventEmitter {
    constructor(connection) {
        super();
        this.connected = false;
        this.send = (method, params = {}) => __awaiter(this, void 0, void 0, function* () {
            let result;
            switch (method) {
                case types_1.ChannelMethods.chan_setUserWithdrawal:
                    result = yield this.setUserWithdrawal(params.withdrawalObject, params.remove);
                    break;
                case types_1.ChannelMethods.chan_getUserWithdrawal:
                    result = yield this.getUserWithdrawals();
                    break;
                case types_1.ChannelMethods.chan_signMessage:
                    result = yield this.signMessage(params.message);
                    break;
                case types_1.ChannelMethods.chan_encrypt:
                    result = yield this.encrypt(params.message, params.publicIdentifier);
                    break;
                case types_1.ChannelMethods.chan_decrypt:
                    result = yield this.decrypt(params.encryptedPreImage);
                    break;
                case types_1.ChannelMethods.chan_restoreState:
                    result = yield this.restoreState();
                    break;
                case types_1.ChannelMethods.chan_setStateChannel:
                    result = yield this.setStateChannel(params.state, params.setupCommitment, params.setStateCommitments, params.conditionalCommitments);
                    break;
                case types_1.ChannelMethods.chan_walletDeposit:
                    result = yield this.walletDeposit(params);
                    break;
                case types_1.ChannelMethods.chan_getSchemaVersion:
                    result = yield this.getSchemaVersion();
                    break;
                case types_1.ChannelMethods.chan_updateSchemaVersion:
                    result = yield this.updateSchemaVersion(params.version);
                    break;
                default:
                    result = yield this._send(method, params);
                    break;
            }
            return result;
        });
        this.on = (event, listener) => {
            this.connection.on(event, listener);
            return this.connection;
        };
        this.once = (event, listener) => {
            this.connection.once(event, listener);
            return this.connection;
        };
        this.removeAllListeners = () => {
            this.connection.removeAllListeners();
            return this.connection;
        };
        this.walletDeposit = (params) => __awaiter(this, void 0, void 0, function* () {
            return this._send(types_1.ChannelMethods.chan_walletDeposit, params);
        });
        this.getUserWithdrawals = () => __awaiter(this, void 0, void 0, function* () {
            return this._send(types_1.ChannelMethods.chan_getUserWithdrawal, {});
        });
        this.setUserWithdrawal = (withdrawalObject, remove = false) => __awaiter(this, void 0, void 0, function* () {
            return this._send(types_1.ChannelMethods.chan_setUserWithdrawal, {
                withdrawalObject,
                remove,
            });
        });
        this.restoreState = () => __awaiter(this, void 0, void 0, function* () {
            return this._send(types_1.ChannelMethods.chan_restoreState, {});
        });
        this.setStateChannel = (state, setupCommitment, setStateCommitments, conditionalCommitments) => __awaiter(this, void 0, void 0, function* () {
            return this._send(types_1.ChannelMethods.chan_setStateChannel, {
                state,
                setupCommitment,
                setStateCommitments,
                conditionalCommitments,
            });
        });
        this.connection = connection;
    }
    enable() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            yield this.connection.open();
            let config;
            try {
                config = yield this._send(types_1.ChannelMethods.chan_enable);
            }
            catch (e) {
                return reject(`Could not enable channel: ${e.message}`);
            }
            if (Object.keys(config).length > 0) {
                this.connected = true;
                this._config = config;
                this._multisigAddress = config.multisigAddress;
                this.emit("connect");
                return resolve(config);
            }
            else {
                const err = new Error("User Denied Channel Config");
                err.code = 4001;
                this.connected = false;
                yield this.connection.close();
                return reject(err);
            }
        }));
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.connection.close();
            this.connected = false;
        });
    }
    get config() {
        return this._config;
    }
    get multisigAddress() {
        const multisigAddress = this._multisigAddress ||
            (typeof this._config !== "undefined" ? this._config.multisigAddress : undefined);
        return multisigAddress;
    }
    set multisigAddress(multisigAddress) {
        if (typeof this._config !== "undefined") {
            this._config.multisigAddress = multisigAddress;
        }
        this._multisigAddress = multisigAddress;
    }
    get signerAddress() {
        return this.config.signerAddress;
    }
    set signerAddress(signerAddress) {
        this.config.signerAddress = signerAddress;
    }
    isSigner() {
        return this._send(types_1.ChannelMethods.chan_isSigner);
    }
    signMessage(message) {
        return this._send(types_1.ChannelMethods.chan_signMessage, { message });
    }
    encrypt(message, publicIdentifier) {
        return this._send(types_1.ChannelMethods.chan_encrypt, {
            message,
            publicIdentifier,
        });
    }
    decrypt(encryptedPreImage) {
        return this._send(types_1.ChannelMethods.chan_decrypt, {
            encryptedPreImage,
        });
    }
    getSchemaVersion() {
        return this._send(types_1.ChannelMethods.chan_getSchemaVersion);
    }
    updateSchemaVersion(version) {
        return this._send(types_1.ChannelMethods.chan_updateSchemaVersion, { version });
    }
    _send(method, params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = { id: Date.now(), jsonrpc: "2.0", method, params };
            const result = yield this.connection.send(payload);
            return result;
        });
    }
}
exports.ChannelProvider = ChannelProvider;
//# sourceMappingURL=channelProvider.js.map